export class Generic {
  constructor(
    public id: string,
    public value: string
  ) { }
}
